import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { CONTACT } from "@/data/site";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const QUICK_LINKS = [
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Projects", id: "projects" },
  { label: "Reviews", id: "testimonials" },
  { label: "Get a Quote", id: "contact" },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={CONTACT.logo}
                alt="CWood Construction"
                className="h-12 w-12 rounded-lg object-cover bg-white"
              />
              <span className="font-heading font-extrabold text-xl text-white">
                CWood Construction
              </span>
            </div>
            <p className="text-slate-400 leading-relaxed text-sm max-w-xs">
              Professional Construction & Landscaping Services. Building quality and
              creating outdoor spaces across Huddersfield and West Yorkshire.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-slate-400 hover:text-[#7fb0ff] transition-colors text-sm"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-5">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={`tel:${CONTACT.phoneTel}`} className="flex items-center gap-3 hover:text-[#7fb0ff] transition-colors">
                  <Phone size={16} className="text-[#7fb0ff]" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-[#7fb0ff] transition-colors break-all">
                  <Mail size={16} className="text-[#7fb0ff] flex-shrink-0" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-[#7fb0ff]" /> {CONTACT.location}
              </li>
              <li>
                <a href={CONTACT.facebookUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#7fb0ff] transition-colors">
                  <Facebook size={16} className="text-[#7fb0ff]" /> {CONTACT.facebook}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-slate-500">
          <span>© {new Date().getFullYear()} CWood Construction. All rights reserved.</span>
          <span>Huddersfield | West Yorkshire</span>
        </div>
      </div>
    </footer>
  );
};
